var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.48 468.27C245.48 455.23 245.48 390.03 245.48 272.66C217.54 272.66 202.02 272.66 198.91 272.66C195.54 272.66 192.42 270.83 190.77 267.88C189.13 264.93 189.21 261.32 190.99 258.44C203.1 238.88 299.97 82.4 312.08 62.84C315.48 57.36 324.52 57.36 327.92 62.84C340.03 82.4 436.9 238.88 449.01 258.44C450.79 261.32 450.87 264.93 449.23 267.88C447.58 270.83 444.46 272.66 441.09 272.66C437.98 272.66 422.46 272.66 394.52 272.66C394.52 390.03 394.52 455.23 394.52 468.27C394.52 473.41 390.35 477.58 385.2 477.58C359.12 477.58 267.84 477.58 254.8 477.58C249.65 477.58 245.48 473.41 245.48 468.27ZM375.89 263.35C375.89 258.21 380.05 254.03 385.2 254.03C387.81 254.03 400.87 254.03 424.37 254.03C417.41 242.79 382.62 186.59 320 85.44C257.38 186.59 222.59 242.79 215.63 254.03C239.13 254.03 252.19 254.03 254.8 254.03C259.94 254.03 264.11 258.21 264.11 263.35C264.11 276.39 264.11 341.59 264.11 458.95C271.56 458.95 308.82 458.95 375.89 458.95C375.89 337.24 375.89 272.04 375.89 263.35Z",
    id: "celrR0ouT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.48 468.27C245.48 455.23 245.48 390.03 245.48 272.66C217.54 272.66 202.02 272.66 198.91 272.66C195.54 272.66 192.42 270.83 190.77 267.88C189.13 264.93 189.21 261.32 190.99 258.44C203.1 238.88 299.97 82.4 312.08 62.84C315.48 57.36 324.52 57.36 327.92 62.84C340.03 82.4 436.9 238.88 449.01 258.44C450.79 261.32 450.87 264.93 449.23 267.88C447.58 270.83 444.46 272.66 441.09 272.66C437.98 272.66 422.46 272.66 394.52 272.66C394.52 390.03 394.52 455.23 394.52 468.27C394.52 473.41 390.35 477.58 385.2 477.58C359.12 477.58 267.84 477.58 254.8 477.58C249.65 477.58 245.48 473.41 245.48 468.27ZM375.89 263.35C375.89 258.21 380.05 254.03 385.2 254.03C387.81 254.03 400.87 254.03 424.37 254.03C417.41 242.79 382.62 186.59 320 85.44C257.38 186.59 222.59 242.79 215.63 254.03C239.13 254.03 252.19 254.03 254.8 254.03C259.94 254.03 264.11 258.21 264.11 263.35C264.11 276.39 264.11 341.59 264.11 458.95C271.56 458.95 308.82 458.95 375.89 458.95C375.89 337.24 375.89 272.04 375.89 263.35Z",
    id: "c1aj2bLU65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77 561.41C105.77 551.17 105.77 469.2 105.77 458.95C105.77 453.81 109.93 449.64 115.08 449.64C120.67 449.64 165.38 449.64 170.97 449.64C176.12 449.64 180.28 453.81 180.28 458.95C180.28 461.44 180.28 473.89 180.28 496.31C208.22 496.31 431.78 496.31 459.72 496.31C459.72 474.16 459.72 461.85 459.72 459.39C459.72 454.25 463.88 450.08 469.03 450.08C474.62 450.08 519.33 450.08 524.92 450.08C530.07 450.08 534.23 454.25 534.23 459.39C534.23 469.6 534.23 551.21 534.23 561.41C534.23 566.56 530.07 570.73 524.92 570.73C442.95 570.73 156.06 570.73 115.08 570.73C109.93 570.73 105.77 566.56 105.77 561.41ZM515.6 468.71C493.24 468.71 480.82 468.71 478.34 468.71C478.34 490.86 478.34 503.16 478.34 505.62C478.34 510.76 474.18 514.94 469.03 514.94C439.22 514.94 200.77 514.94 170.97 514.94C165.82 514.94 161.65 510.76 161.65 505.62C161.65 503.13 161.65 490.68 161.65 468.27C159.17 468.27 146.75 468.27 124.39 468.27L124.39 552.1L515.6 552.1L515.6 468.71Z",
    id: "a8SYResJRJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77 561.41C105.77 551.17 105.77 469.2 105.77 458.95C105.77 453.81 109.93 449.64 115.08 449.64C120.67 449.64 165.38 449.64 170.97 449.64C176.12 449.64 180.28 453.81 180.28 458.95C180.28 461.44 180.28 473.89 180.28 496.31C208.22 496.31 431.78 496.31 459.72 496.31C459.72 474.16 459.72 461.85 459.72 459.39C459.72 454.25 463.88 450.08 469.03 450.08C474.62 450.08 519.33 450.08 524.92 450.08C530.07 450.08 534.23 454.25 534.23 459.39C534.23 469.6 534.23 551.21 534.23 561.41C534.23 566.56 530.07 570.73 524.92 570.73C442.95 570.73 156.06 570.73 115.08 570.73C109.93 570.73 105.77 566.56 105.77 561.41ZM515.6 468.71C493.24 468.71 480.82 468.71 478.34 468.71C478.34 490.86 478.34 503.16 478.34 505.62C478.34 510.76 474.18 514.94 469.03 514.94C439.22 514.94 200.77 514.94 170.97 514.94C165.82 514.94 161.65 510.76 161.65 505.62C161.65 503.13 161.65 490.68 161.65 468.27C159.17 468.27 146.75 468.27 124.39 468.27L124.39 552.1L515.6 552.1L515.6 468.71Z",
    id: "bx5n2Wmqo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 0C86.95 0 58.68 11.74 35.21 35.21C11.74 58.68 0 86.95 0 120C0 160 0 480 0 520C0 553.05 11.74 581.32 35.21 604.79C58.68 628.26 86.95 640 120 640C160 640 480.01 640 520.01 640C553.06 640 581.33 628.26 604.79 604.79C628.26 581.32 640 553.05 640 520C640 480 640 160 640 120C640 86.95 628.26 58.67 604.79 35.21C581.33 11.74 553.06 0 520.01 0C480.01 0 160 0 120 0Z",
    id: "a1bgwYKeEz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 0C86.95 0 58.68 11.74 35.21 35.21C11.74 58.68 0 86.95 0 120C0 160 0 480 0 520C0 553.05 11.74 581.32 35.21 604.79C58.68 628.26 86.95 640 120 640C160 640 480.01 640 520.01 640C553.06 640 581.33 628.26 604.79 604.79C628.26 581.32 640 553.05 640 520C640 480 640 160 640 120C640 86.95 628.26 58.67 604.79 35.21C581.33 11.74 553.06 0 520.01 0C480.01 0 160 0 120 0Z",
    id: "c2M3Ue79fX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35 257.79C122.69 244.75 93.37 140.39 89.7 127.35C89.66 127.2 89.63 127.06 89.59 126.91C85.14 105.86 99.63 85.41 122.57 80.34C126.63 79.45 159.06 72.28 163.11 71.39C167.58 70.4 172.07 72.88 173.16 76.93C174.24 80.98 171.51 85.06 167.05 86.05C162.99 86.94 130.56 94.11 126.51 95C112.27 98.15 103.25 110.8 105.88 123.86C109.55 136.9 138.86 241.24 142.53 254.28C142.57 254.42 142.6 254.57 142.64 254.72C150.09 289.97 184.2 315.55 223.75 315.55C263.3 315.55 297.42 289.97 304.87 254.72C304.9 254.57 304.93 254.42 304.97 254.28C308.64 241.24 337.96 136.9 341.62 123.86C344.26 110.8 335.24 98.15 320.99 95C316.94 94.11 284.51 86.94 280.46 86.05C275.99 85.06 273.26 80.98 274.34 76.93C275.43 72.88 279.92 70.4 284.39 71.39C288.44 72.28 320.87 79.45 324.93 80.34C347.87 85.41 362.36 105.86 357.91 126.91C357.88 127.06 357.84 127.2 357.8 127.35C354.13 140.39 324.81 244.75 321.15 257.79C312.1 300.02 271.18 330.64 223.75 330.64C176.32 330.64 135.4 300.02 126.35 257.79Z",
    id: "aVxHSLOXN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66 102.61C190.97 101.21 200.5 90.28 198.96 78.2C197.41 66.13 185.37 57.48 172.06 58.88C158.75 60.28 140.18 72.16 141.73 84.24C143.28 96.32 164.35 104.01 177.66 102.61Z",
    id: "ayIsG2Wli"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.84 102.61C256.53 101.21 247 90.28 248.55 78.2C250.09 66.13 262.13 57.48 275.44 58.88C288.75 60.28 307.32 72.16 305.77 84.24C304.23 96.32 283.15 104.01 269.84 102.61Z",
    id: "aW3iM4kQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.07 437.28C209.08 427.35 209.08 347.95 209.08 338.03C209.08 336.57 207.92 335.32 206.34 335.08C206.34 335.08 206.34 335.08 206.34 335.08C173.08 330.03 144.25 310.64 129.21 283.2C126.99 279.14 127.22 274.4 129.82 270.51C132.45 266.56 137.05 264.15 142.11 264.07C142.13 264.07 142.35 264.07 142.37 264.07C147.87 264.07 153.09 267.06 155.66 271.68C168.7 295.18 194.8 309.78 223.75 309.78C252.49 309.78 279.31 294.66 292.08 271.26C294.47 266.89 299.58 264.07 305.1 264.07C310.23 264.07 314.91 266.43 317.61 270.4C320.29 274.31 320.54 279.1 318.29 283.2C303.26 310.64 274.43 330.03 241.17 335.08C241.11 335.09 240.69 335.13 240.64 335.13C238.96 335.29 237.69 336.57 237.69 338.1C237.69 348.02 237.73 427.35 237.73 437.26C237.73 489.91 284.91 532.72 342.91 532.72C346.76 532.72 377.57 532.72 381.42 532.72C439.51 532.72 486.6 489.99 486.6 437.28C486.6 422.33 486.6 347.59 486.6 213.04L515.26 213.04C515.26 347.58 515.26 422.33 515.26 437.28C515.26 504.35 455.34 558.73 381.42 558.73C378.86 558.73 366.02 558.73 342.91 558.73C253.69 522.41 209.07 481.92 209.07 437.28Z",
    id: "b3KdaB5jLe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.2 156.18C466.06 156.18 439.2 180.56 439.2 210.63C439.2 240.71 466.06 265.09 499.2 265.09C532.34 265.09 559.21 240.71 559.21 210.63C559.21 180.56 532.34 156.18 499.2 156.18Z",
    id: "d2a4A1DgHx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.74 264.84C535.28 262.3 559.2 239.01 559.2 210.63C559.2 182.25 535.28 158.96 504.74 156.42C504.74 178.1 504.74 254 504.74 264.84Z",
    id: "dJknZY5xX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.2 189.42C486.29 189.42 475.83 198.92 475.83 210.63C475.83 222.35 486.29 231.85 499.2 231.85C512.12 231.85 522.58 222.35 522.58 210.63C522.58 198.92 512.12 189.42 499.2 189.42Z",
    id: "d58LgbkD4R"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#celrR0ouT",
    opacity: 1,
    fill: "#fffefe",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#celrR0ouT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1aj2bLU65",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1aj2bLU65",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8SYResJRJ",
    opacity: 1,
    fill: "#fffefe",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8SYResJRJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bx5n2Wmqo",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bx5n2Wmqo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1bgwYKeEz",
    opacity: 1,
    fill: "#3F67F6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1bgwYKeEz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2M3Ue79fX",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2M3Ue79fX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aVxHSLOXN",
    opacity: 1,
    fill: "#caddea",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aVxHSLOXN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ayIsG2Wli",
    opacity: 1,
    fill: "#65db57",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ayIsG2Wli",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aW3iM4kQ",
    opacity: 1,
    fill: "#65db57",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aW3iM4kQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3KdaB5jLe",
    opacity: 1,
    fill: "#2c5871",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3KdaB5jLe",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2a4A1DgHx",
    opacity: 1,
    fill: "#5d6d7d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2a4A1DgHx",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dJknZY5xX",
    opacity: 1,
    fill: "#35495d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dJknZY5xX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d58LgbkD4R",
    opacity: 1,
    fill: "#e1effb",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d58LgbkD4R",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.94284b94145efd329cdccf8fa8c53999.svg";
export { ForwardRef as ReactComponent };